import React from "react";
import RecipeCard from "./RecipeCard";

const MealSection = React.memo(({ 
  day, 
  meal, 
  recipes, 
  onViewRecipe, 
  onEditRecipe, 
  onDeleteRecipe
}) => {
  const mealRecipes = recipes.filter(
    (recipe) => recipe.day === day && recipe.meal === meal
  );

  if (mealRecipes.length === 0) {
    return null;
  }

  return (
    <div className="meal-section">
      <div className={`meal-header ${meal.toLowerCase()}`}>
        <span className={`meal-icon ${meal.toLowerCase()}`}></span>
        {meal}
      </div>
      <div className="meal-recipes">
        {mealRecipes.map((recipe) => (
          <RecipeCard
            key={recipe.id}
            recipe={recipe}
            onView={onViewRecipe}
            onEdit={onEditRecipe}
            onDelete={onDeleteRecipe}
          />
        ))}
      </div>
    </div>
  );
});

export default MealSection;